import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Thin wrapper around the SVG `<rect>` element, forwarding all props.
 * @param props - Any SVG rect attributes (size, position, style…).
 * @returns The `<rect>` element.
 */
export function Rectangle(props) {
    return _jsx("rect", { ...props });
}
//# sourceMappingURL=Rectangle.js.map